import { get, post, remove, patch } from 'api.vanilla.service';
import { formatErrorMessage } from 'api/helpers';
import { set as setFeedback } from 'feedback.vanilla.service.js';

// phrases
import phrases from './nutritionValues.phrases';

function getUrl(useGlobalResource) {
	return useGlobalResource ? '/product/global_nutrition_values' : '/product/nutrition_values';
}

/**
 * @function fetchAllNutritionValues
 * @description Fetch all nutrition values
 * @param {object} state
 */
export function fetchAllNutritionValues(state, useGlobalResource) {
	// Set params and filter
	const params = {
		limit: state.limit,
		sort: state.sort,
		offset: state.offset,
		filter: state.filter,
	};

	const url = getUrl(useGlobalResource);

	return get(url, params, null, state.headers)
		.then((res) => {
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
		});
}

/**
 * @function addNutritionValues
 * @description adds nutrition values
 */
export function addNutritionValues(data, useGlobalResource) {
	const url = getUrl(useGlobalResource);

	return post(url, data)
		.then((res) => {
			setFeedback(phrases.NUTRITION_VALUES_ADDED, 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}

/**
 * @function editNutritionValues
 * @description edits a nutrition value
 */
export function editNutritionValues(nutritionId, data, useGlobalResource) {
	const url = getUrl(useGlobalResource);

	return post(`${url}/${nutritionId}`, data)
		.then((res) => {
			setFeedback(phrases.NUTRITION_VALUE_EDITED, 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}

/**
 * @function editBatchNutritionValues
 * @description edit
 */
export function editBatchNutritionValues(data, useGlobalResource) {
	const url = getUrl(useGlobalResource);

	return patch(url, data)
		.then((res) => {
			setFeedback(phrases.NUTRITION_VALUES_EDITED, 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}

/**
 * @function deleteNutritionValues
 * @description del
 */
export function deleteNutritionValues(nutritionId, useGlobalResource) {
	const url = getUrl(useGlobalResource);

	return remove(`${url}/${nutritionId}`)
		.then((res) => {
			setFeedback(phrases.NUTRITION_VALUES_DELETED, 1);
			return res;
		})
		.catch((err) => {
			const errorMessage = formatErrorMessage(err);
			setFeedback(errorMessage, 0);
			throw err;
		});
}
